import { Checkbox, ListItem, ListItemIcon } from '@mui/material';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Button, Modal, Spinner, Table } from 'reactstrap';

import { Constants } from '@/constants';

const VitolaMerger = ({
  open,
  onClose,
  onCancel,
  sourceVitola,
  onMerged = () => {},
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [query, setQuery] = useState('');
  const [cigarVitolas, setCigarVitolas] = useState([]);
  const [vitolas, setVitolas] = useState([]);
  const [targetVitola, setTargetVitola] = useState({});
  const [mergePlan, setMergePlan] = useState({});
  const [merging, setMerging] = useState(false);
  const [loading, setLoading] = useState(false);

  const mergedVitola = useMemo(() => {
    const m = { ...targetVitola };
    mergePlan.fieldChanges?.forEach(({ field, to }) => {
      m[field] = to;
    });
    return m;
  }, [mergePlan, targetVitola]);

  useEffect(() => {
    const loadVitolas = () => {
      const vitolasUrl = `${Constants.apiPath}/cigars/datatables/vitolas/all`;
      console.log(vitolasUrl);
      axios
        .get(vitolasUrl, {
          params: {
            cigar_id: sourceVitola?.cigar_id,
          },
        })
        .then((res) => {
          const allVitolas = res.data.data.filter(
            (v) => v.id !== sourceVitola.id
          );
          setCigarVitolas(allVitolas);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    if (sourceVitola && sourceVitola.cigar_id) {
      loadVitolas();
    }
  }, [sourceVitola]);

  useEffect(() => {
    if (sourceVitola && cigarVitolas) {
      console.log('Cigar vitolas:', cigarVitolas);
      let filteredVitolas = cigarVitolas;
      if (query.length > 0) {
        const q = (query ?? '').toLowerCase();
        filteredVitolas = cigarVitolas.filter((v) =>
          (v.formatted_name ?? '').toLowerCase().includes(q)
        );
      } else {
        filteredVitolas = cigarVitolas.filter((v) => {
          const shapeMatch = sourceVitola.shape
            ? v.shape?.toLowerCase().includes(sourceVitola.shape.toLowerCase())
            : false;
          const aliasMatch = sourceVitola.alias
            ? v.alias?.toLowerCase().includes(sourceVitola.alias.toLowerCase())
            : false;
          return shapeMatch || aliasMatch;
        });
      }
      console.log('Filtered Vitolas:', filteredVitolas);
      setVitolas(filteredVitolas);
    }
  }, [query, sourceVitola, cigarVitolas]);

  const getMergePreview = () => {
    if (targetVitola) {
      setLoading(true);
      axios
        .post(
          `${Constants.apiPath}/cigars/vitolas/${targetVitola.id}/merge/${sourceVitola.id}/preview`
        )
        .then((res) => {
          console.log(res.data);
          setMergePlan(res.data);
          setShowConfirmModal(true);
          if (typeof onClose === 'function') {
            onClose();
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      // TODO Error if no mergeVitola selected
    }
  };

  const merge = () => {
    if (targetVitola) {
      setMerging(true);
      axios
        .post(
          `${Constants.apiPath}/cigars/vitolas/${targetVitola.id}/merge/${sourceVitola.id}`
        )
        .then((res) => {
          console.log(res.data);
          setShowConfirmModal(false);
          if (typeof onMerged === 'function') {
            onMerged(res.data);
          }
        })
        .catch((e) => {
          console.log(e);
          // TODO Error alert
        })
        .finally(() => {
          setMerging(false);
        });
    } else {
      // TODO Error if no mergeVitola selected
    }
  };

  const renderMergeModal = () => (
    <Modal isOpen={open} onClosed={onClose} toggle={onClose}>
      <div
        className="modal-header"
        style={{ flexDirection: 'column', alignItems: 'flex-start' }}
      >
        <h5 className="modal-title">{'Merge Vitola'}</h5>
        <div style={{ marginTop: 12, width: '100%' }}>
          Select vitola to merge into:
          <input
            className="form-control sticky"
            placeholder="Search vitolas..."
            value={query}
            onChange={(event) => {
              setQuery(event.target.value);
            }}
          />
        </div>
      </div>
      <div
        className="modal-body"
        style={{ maxHeight: isMobile ? '80vh' : 500, overflowY: 'auto' }}
      >
        <List>
          {vitolas.length > 0 &&
            vitolas.map((vitola) => (
              <ListItem
                key={`vitola-item-${vitola.id}`}
                onClick={() => setTargetVitola(vitola)}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={targetVitola.id === vitola.id}
                    tabIndex={-1}
                    disableRipple
                    color="secondary"
                    inputProps={{ 'aria-labelledby': vitola.formatted_name }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {vitola.image_url && (
                        <img
                          src={vitola.image_url}
                          alt=""
                          style={{
                            height: 'auto',
                            width: 180,
                            marginLeft: 8,
                            marginBottom: 6,
                          }}
                        />
                      )}
                      <span
                        className="padded-multiline"
                        style={{ marginLeft: 10 }}
                      >
                        {/* TODO Break each up? Might be easier to see which should be used */}
                        {vitola.formatted_name}
                      </span>
                    </div>
                  }
                />
              </ListItem>
            ))}
          {vitolas.length === 0 && (
            <div style={{ textAlign: 'center', margin: 10 }}>
              No vitolas found
            </div>
          )}
        </List>
      </div>
      <div className="modal-footer">
        <Button color="light" onClick={onCancel}>
          {'Cancel'}
        </Button>
        <Button
          onClick={getMergePreview}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading && (
            <Spinner color="dark" style={{ marginRight: 8 }} size="sm" />
          )}
          {loading ? 'Getting data...' : 'Continue'}
        </Button>
      </div>
    </Modal>
  );

  const formatCell = (cellName: string, cellValue: any) => {
    if (cellName === 'cigar' && cellValue) {
      return (
        <div>
          <div>{cellValue.full_name}</div>
        </div>
      );
    }
    if (cellName === 'image_url' && cellValue) {
      return (
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div>
            <img
              src={cellValue}
              style={{ height: 'auto', width: 220, objectFit: 'contain' }}
              alt={cellValue}
            />
          </div>
        </div>
      );
    }
    return String(cellValue);
  };

  const renderMergeConfirmationModal = () => {
    return (
      <Modal
        isOpen={showConfirmModal}
        toggle={() => setShowConfirmModal(false)}
        onClosed={() => setShowConfirmModal(false)}
        style={{ maxWidth: 800 }}
      >
        <div className="modal-header">
          <h5 className="modal-title h2">Confirm</h5>
        </div>
        <div className="modal-body">
          <p>Please confirm the vitola details after the merge:</p>
          <Table bordered>
            <thead>
              <tr>
                <th>Field</th>
                <th>Current Value</th>
                <th>After Merge</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(mergedVitola)
                .filter((k) => k !== 'image_uri')
                .map((field) => {
                  const change = mergePlan.fieldChanges?.find(
                    (c) => c.field === field
                  );
                  const isChanged = Boolean(change);
                  return (
                    <tr
                      key={field}
                      className={isChanged ? 'table-success' : ''}
                    >
                      <td style={{ textTransform: 'capitalize' }}>
                        {field.replace(/_/g, ' ')}
                      </td>
                      <td>
                        {formatCell(
                          field,
                          change ? change.from : targetVitola[field]
                        )}
                      </td>
                      <td>{formatCell(field, mergedVitola[field])}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>

          <h4>Related Records to Reassign</h4>
          <Table bordered>
            <thead>
              <tr>
                <th>Association</th>
                <th># of Records Affected</th>
              </tr>
            </thead>
            <tbody>
              {mergePlan.associations?.map(({ table, count }) => (
                <tr key={table}>
                  <td>{table}</td>
                  <td>{count}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="modal-footer">
          <Button
            onClick={() => {
              setShowConfirmModal(false);
              if (typeof onCancel === 'function') {
                onCancel();
              }
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={merging}
            onClick={merge}
            variant="contained"
            color="danger"
          >
            {merging && (
              <Spinner
                type="border"
                color="dark"
                size="sm"
                style={{ marginRight: 10 }}
              />
            )}
            {merging ? 'Merging...' : 'Confirm'}
          </Button>
        </div>
      </Modal>
    );
  };

  return (
    <>
      {renderMergeModal()}
      {renderMergeConfirmationModal()}
    </>
  );
};

export default VitolaMerger;
